import React from 'react'
import Icon from '@ant-design/icons';

export default (props) => {
  const {
    color = '#919191', // цвет знака
  } = props;

  const icon_color = color || 'currentColor';

  const SvgIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C4.48138 0 0 4.48069 0 10C0 15.5193 4.48138 20 10 20C15.5193 20 20 15.5193 20 10C20 4.48069 15.5193 0 10 0ZM10 0.689655C15.1386 0.689655 19.3103 4.86138 19.3103 10C19.3103 15.1386 15.1386 19.3103 10 19.3103C4.86207 19.3103 0.689655 15.1386 0.689655 10C0.689655 4.86138 4.86207 0.689655 10 0.689655ZM13.2041 11.2324L12.7862 11.631C12.5372 11.8793 12.2 12.0193 11.8489 12.0193C11.4972 12.0193 11.16 11.8793 10.911 11.631L8.60482 9.32414C8.35517 9.07517 8.21516 8.73655 8.21516 8.38414C8.21516 8.03173 8.35517 7.6938 8.60482 7.44483C8.48068 7.56828 8.79725 7.25103 8.9869 7.06C9.55931 6.48414 9.55792 5.55379 8.98412 4.97931L7.79242 3.78828C7.4538 3.44966 6.98483 3.27586 6.5069 3.31172C6.02965 3.34759 5.59171 3.58965 5.30758 3.97517L4.83449 4.61793C3.49656 6.4331 3.68618 8.95379 5.28135 10.5483C6.58411 11.8517 8.16414 13.431 9.46828 14.7352C11.0648 16.3317 13.5889 16.52 15.4048 15.1772C15.6262 15.0138 15.8414 14.8545 16.0421 14.7062C16.4269 14.4221 16.6683 13.9841 16.7041 13.5069C16.7393 13.0297 16.5655 12.5614 16.2269 12.2228L15.2621 11.2572C14.6966 10.6917 13.7828 10.6807 13.2041 11.2324ZM13.2731 12.1193L13.6793 11.7317C13.9876 11.4386 14.4731 11.4441 14.7745 11.7448L15.7393 12.7103C15.9358 12.9069 16.0365 13.1786 16.0158 13.4559C15.9958 13.7324 15.8552 13.9869 15.6324 14.1517C15.4317 14.3 15.2166 14.4593 14.9945 14.6228C13.4538 15.7621 11.311 15.6028 9.95584 14.2476C8.65171 12.9434 7.07172 11.3641 5.76896 10.0607C4.41517 8.7069 4.25379 6.56759 5.38966 5.0269L5.86274 4.38483C6.02757 4.16069 6.28206 4.02 6.5593 3.99931C6.83585 3.97862 7.10826 4.07931 7.30481 4.27586L8.49584 5.4669C8.80136 5.77241 8.80204 6.26759 8.4979 6.5738C8.30756 6.76483 8.11654 6.95655 8.11654 6.95655C7.73792 7.33517 7.52551 7.84897 7.52551 8.38414C7.52551 8.92 7.73792 9.4331 8.11654 9.81173L10.4234 12.1186C10.8013 12.4966 11.3145 12.709 11.8489 12.709C12.3827 12.709 12.8952 12.4966 13.2731 12.1193Z"
        fill={icon_color}
      />
    </svg>
  );

  return <Icon component={SvgIcon} {...props} />;
}
